module.exports = __webpack_public_path__ + "assets/images/GBP50.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/GBP50.png
// module id = 1382
// module chunks = 1